var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreEssentials3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.5C15.8578 27.5 12.5 24.1423 12.5 20C12.5 16.6415 14.7072 13.799 17.75 12.8435V14.4365C16.4607 14.96 15.3933 15.9153 14.7305 17.1388C14.0677 18.3624 13.8507 19.7782 14.1164 21.1442C14.3822 22.5101 15.1143 23.7412 16.1876 24.627C17.2608 25.5128 18.6085 25.9981 20 26C21.1953 26 22.3634 25.643 23.3546 24.9749C24.3458 24.3068 25.115 23.358 25.5635 22.25H27.1565C26.201 25.2928 23.3585 27.5 20 27.5ZM27.4625 20.75H19.25V12.5375C19.4967 12.5127 19.7473 12.5 20 12.5C24.1423 12.5 27.5 15.8578 27.5 20C27.5 20.2527 27.4873 20.5033 27.4625 20.75ZM20.75 14.0465V19.25H25.9535C25.7866 17.9282 25.1846 16.6995 24.2426 15.7574C23.3005 14.8154 22.0718 14.2134 20.75 14.0465Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreEssentials3);
export default __webpack_public_path__ + "static/media/core_essentials3.d8995d3fc685a025eb6cd37208cdc525.svg";
export { ForwardRef as ReactComponent };